var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareBuyPrompt = function SvgIconShareBuyPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M13.913 5.027c-.006.008-.013.023-.013.054V7c0 1.07-.857 1.85-1.81 1.945a9.11 9.11 0 0 0-7.933 6.897A9.9 9.9 0 0 1 11 13.1h1c1.049 0 1.9.85 1.9 1.9v1.92c0 .03.007.045.013.053a.1.1 0 0 0 .043.036q.034.014.056.012a.1.1 0 0 0 .05-.024l7.4-5.919a.1.1 0 0 0 0-.156l-7.4-5.92a.1.1 0 0 0-.05-.023.1.1 0 0 0-.056.011.1.1 0 0 0-.043.037M2.1 18c0 .592.423.986.86 1.092.424.103.942-.037 1.236-.493A8.1 8.1 0 0 1 11 14.9h1a.1.1 0 0 1 .1.1v1.92c0 1.593 1.844 2.48 3.088 1.484l7.399-5.92a1.9 1.9 0 0 0 0-2.967l-7.4-5.92c-1.243-.994-3.086-.109-3.086 1.485V7c0 .024-.008.052-.04.084a.24.24 0 0 1-.148.07C6.402 7.7 2.1 12.347 2.1 18",
    clipRule: "evenodd"
  })));
};
export default SvgIconShareBuyPrompt;